(function () {
  // Scrollen über dem Bild bewegt die linke Seite
  document.querySelectorAll('.svm-split').forEach(function (split) {
    var left = split.querySelector('.svm-left');
    var right = split.querySelector('.svm-right');
    if (!left || !right) return;
    right.addEventListener('wheel', function (e) {
      if (window.innerWidth < 990) return;
      left.scrollTop += e.deltaY;
      e.preventDefault();
    }, { passive: false });
  });

  // Startseite: Bild wechselt beim Überfahren der Reiter
  document.querySelectorAll('[data-svm-hover]').forEach(function (root) {
    var media = document.querySelector(root.getAttribute('data-svm-hover'));
    if (!media) return;
    var flower = document.querySelector('.svm-flower[data-svm-hide]');
    var timer = null;
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function show(key) {
      clearInterval(timer);
      var list = [];
      media.querySelectorAll('img').forEach(function (img) {
        img.classList.remove('is-active');
        if (img.getAttribute('data-key') === key) list.push(img);
      });
      if (!list.length && key !== 'start') return show('start');
      if (list.length) list[0].classList.add('is-active');
      if (list.length > 1 && !still) {
        var i = 0;
        timer = setInterval(function () {
          list[i].classList.remove('is-active');
          i = (i + 1) % list.length;
          list[i].classList.add('is-active');
        }, 2200);
      }
      if (flower) flower.classList.toggle('is-hidden', key !== 'start' && list.length > 0);
      root.querySelectorAll('a[data-key]').forEach(function (a) {
        a.classList.toggle('svm-u', a.getAttribute('data-key') === key);
      });
    }
    root.querySelectorAll('a[data-key]').forEach(function (a) {
      a.addEventListener('mouseenter', function () { show(a.getAttribute('data-key')); });
      a.addEventListener('focus', function () { show(a.getAttribute('data-key')); });
    });
    root.addEventListener('mouseleave', function () { show('start'); });
  });

  // Unterseiten: Bilder wechseln automatisch (die Blume bleibt stehen); auf dem Handy auch per Wischen
  document.querySelectorAll('[data-svm-slides]').forEach(function (box) {
    var imgs = box.querySelectorAll('img:not(.svm-flower)');
    if (imgs.length < 2) return;
    var i = 0, timer = null;
    var sec = parseFloat(box.getAttribute('data-svm-slides')) || 4;
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function show(n) {
      imgs[i].classList.remove('is-active');
      i = (n + imgs.length) % imgs.length;
      imgs[i].classList.add('is-active');
    }
    function start() {
      clearInterval(timer);
      if (!still) timer = setInterval(function () { show(i + 1); }, sec * 1000);
    }
    // 30.09.: Wischen nach links = nächstes Foto, nach rechts = vorheriges; danach läuft der Wechsel neu an
    var sx = null, sy = null;
    box.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    box.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      sx = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { show(i + (dx < 0 ? 1 : -1)); start(); }
    });
    start();
  });

  // Shop-Filter
  document.querySelectorAll('[data-svm-filter]').forEach(function (bar) {
    var grid = document.querySelector(bar.getAttribute('data-svm-filter'));
    if (!grid) return;
    bar.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cat = btn.getAttribute('data-cat');
        bar.querySelectorAll('button').forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        grid.querySelectorAll('.svm-card').forEach(function (card) {
          card.hidden = !(cat === 'alle' || card.getAttribute('data-cat') === cat);
        });
      });
    });
  });

  // Produkt: Preis und Verfügbarkeit je Variante
  document.querySelectorAll('[data-svm-product]').forEach(function (form) {
    var data = form.querySelector('script[type="application/json"]');
    var select = form.querySelector('select[name="id"]');
    if (!data || !select) return;
    var variants = JSON.parse(data.textContent);
    var price = document.querySelector('[data-svm-price]');
    var btn = form.querySelector('[data-svm-add]');
    function update() {
      var v = variants.find(function (x) { return String(x.id) === select.value; });
      if (!v) return;
      if (price) price.textContent = v.price;
      if (btn) {
        btn.disabled = !v.available;
        btn.textContent = v.available ? btn.getAttribute('data-add') : btn.getAttribute('data-sold');
      }
    }
    select.addEventListener('change', update);
    update();
  });
  // Projekte: Bildfenster zum Durchklicken
  (function () {
    var lb = document.getElementById('svm-lb');
    if (!lb) return;
    var img = lb.querySelector('.svm-lb__img');
    // 04.10.: Video im Bildfenster – ohne Ton, in Schleife; bei „Bewegung reduzieren“ mit Bedienleiste statt Autostart
    var vid = lb.querySelector('.svm-lb__video');
    var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function stopVideo() {
      if (!vid || !vid.getAttribute('src')) return;
      vid.pause(); vid.removeAttribute('src'); vid.removeAttribute('poster'); vid.load();
    }
    var title = lb.querySelector('#svm-lb-title');
    var count = lb.querySelector('.svm-lb__count');
    var cap = lb.querySelector('.svm-lb__caption');
    var txt = lb.querySelector('.svm-lb__text');
    // 04.10.: langer Projekttext: 3 Zeilen, „Mehr anzeigen“ / „Weniger“
    var more = lb.querySelector('[data-lb-more]');
    function fitText() {
      if (!more) return;
      txt.classList.remove('is-open');
      more.textContent = 'Mehr anzeigen';
      more.hidden = !(txt.scrollHeight > txt.clientHeight + 2);
    }
    var prev = lb.querySelector('[data-lb-prev]');
    var next = lb.querySelector('[data-lb-next]');
    var items = [], i = 0, opener = null;
    function render() {
      var it = items[i];
      var isV = !!(it.video && vid);
      if (vid) vid.hidden = !isV;
      img.hidden = isV;
      if (isV) {
        img.removeAttribute('src'); img.removeAttribute('srcset');
        vid.muted = true; vid.controls = calm;
        if (it.poster) vid.poster = it.poster; else vid.removeAttribute('poster');
        vid.src = it.video;
        if (!calm) { var pl = vid.play(); if (pl && pl.catch) pl.catch(function () {}); }
      } else {
        stopVideo();
        img.src = it.src; img.srcset = it.srcset || ''; img.sizes = '100vw'; img.alt = it.alt || '';
      }
      count.textContent = items.length > 1 ? (i + 1) + ' / ' + items.length : '';
      cap.textContent = it.caption || '';
      cap.hidden = !it.caption;
      prev.hidden = next.hidden = items.length < 2;
      var n = items[(i + 1) % items.length];
      if (n && n !== it && !n.video) { var pre = new Image(); pre.srcset = n.srcset || ''; pre.sizes = '100vw'; pre.src = n.src; }
    }
    function go(d) { if (items.length < 2) return; i = (i + d + items.length) % items.length; render(); }
    function zoom(on) { lb.classList.toggle('is-zoom', on); }
    function open(link) {
      items = [];
      link.querySelectorAll('.svm-project__gallery [data-caption]').forEach(function (w) {
        var v = w.getAttribute('data-video');
        if (v) {
          if (vid) items.push({ video: v, poster: w.getAttribute('data-poster'), caption: w.getAttribute('data-caption') });
          return;
        }
        var im = w.querySelector('img');
        if (!im) return;
        items.push({ src: im.getAttribute('src'), srcset: im.getAttribute('srcset'), alt: im.getAttribute('alt'), caption: w.getAttribute('data-caption') });
      });
      if (!items.length) return;
      i = 0; opener = link;
      title.textContent = (link.querySelector('.svm-label') || {}).textContent || '';
      var t = link.querySelector('.svm-project__text');
      txt.textContent = t ? t.textContent : '';
      zoom(false);
      render();
      lb.hidden = false;
      fitText();
      document.documentElement.classList.add('svm-noscroll');
      lb.querySelector('[data-lb-close]').focus();
    }
    function close() {
      zoom(false);
      lb.hidden = true;
      document.documentElement.classList.remove('svm-noscroll');
      img.removeAttribute('src'); img.removeAttribute('srcset');
      stopVideo();
      if (opener) opener.focus();
    }
    document.querySelectorAll('[data-svm-gallery]').forEach(function (link) {
      link.addEventListener('click', function (e) { e.preventDefault(); open(link); });
    });
    lb.querySelector('[data-lb-close]').addEventListener('click', close);
    if (more) more.addEventListener('click', function () {
      var on = txt.classList.toggle('is-open');
      more.textContent = on ? 'Weniger' : 'Mehr anzeigen';
      if (!on) txt.scrollTop = 0;
    });
    window.addEventListener('resize', function () { if (!lb.hidden && !txt.classList.contains('is-open')) fitText(); });
    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    // 30.09.: Klick auf den Zähler = nächstes Foto
    count.addEventListener('click', function () { go(1); });
    // 30.09.: Klick aufs Foto vergrößert es auf den ganzen Bildschirm, nochmal klicken = zurück
    img.addEventListener('click', function (e) { e.stopPropagation(); zoom(!lb.classList.contains('is-zoom')); });
    if (vid) vid.addEventListener('click', function (e) { e.stopPropagation(); if (!vid.controls) zoom(!lb.classList.contains('is-zoom')); });
    // 30.09.: Klick auf freie Fläche schließt; Text, Titel, Zähler und Knöpfe schließen nicht
    lb.addEventListener('click', function (e) {
      if (lb.classList.contains('is-zoom')) { zoom(false); return; }
      if (e.target.closest('.svm-lb__count, .svm-lb__caption, .svm-lb__text, #svm-lb-title, button')) return;
      close();
    });
    // Wischen im Bildfenster (auch vergrößert): links = weiter, rechts = zurück
    var stage = lb.querySelector('[data-lb-stage]');
    stage.style.touchAction = 'pan-y';
    var sx = null, sy = null;
    stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      sx = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? 1 : -1);
    });
    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') { if (lb.classList.contains('is-zoom')) zoom(false); else close(); }
      else if (e.key === 'ArrowRight') go(1);
      else if (e.key === 'ArrowLeft') go(-1);
      else if (e.key === 'Tab') {
        var f = Array.prototype.filter.call(lb.querySelectorAll('button'), function (b) { return !b.hidden; });
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  })();
})();
